import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import { Thumbnails } from '../Thumbnails';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var Footer = function Footer(_ref) {
  var thumbnails = _ref.thumbnails,
    contentOptions = _ref.contentOptions,
    currentSlide = _ref.currentSlide,
    onThumbnailClick = _ref.onThumbnailClick;
  var withContent = !!(contentOptions !== null && contentOptions !== void 0 && contentOptions.footerContent) && !thumbnails;
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, mergeStyles(styles['container'], withContent && styles['container--with_content'])), {}, {
    children: withContent ? contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.footerContent : /*#__PURE__*/_jsx(Thumbnails, {
      thumbnails: thumbnails || [],
      activeIndex: currentSlide - 1,
      onThumbnailClick: onThumbnailClick
    })
  }));
};
Footer.displayName = 'Footer';